import gql from 'graphql-tag';

import { EventDetailsFragment, SmallEventDetailsFragment } from './EventFragment';
import { DepartmentDataFragment } from './DepartmentFragment';
import {
  AdmissionRoundExamRequiredDetailFragment,
  AdmissionRoundFragment,
} from './AdmissionRoundFragment';

export const MyFavIdsFragment = gql`
  fragment MyFavIdsFragment on MyProfile {
    id
    myDepartmentIds
  }
`;

export const MyFavDepartmentsFragment = gql`
  fragment MyFavDepartmentsFragment on MyProfile {
    id
    ...MyFavIdsFragment
    myDepartments {
      id
      ...DepartmentDataFragment
      events @include(if: $showEvents) {
        ...SmallEventDetailsFragment @include(if: $smallEvent)
        ...EventDetailsFragment @skip(if: $smallEvent)
      }
      admissionRounds @include(if: $includeRound) {
        id
        ...AdmissionRoundFragment @include(if: $includeRound)
        ...AdmissionRoundExamRequiredDetailFragment @include(if: $roundDetails)
      }
      likes @include(if: $showLikes)
    }
  }
  ${MyFavIdsFragment}
  ${EventDetailsFragment}
  ${SmallEventDetailsFragment}
  ${DepartmentDataFragment}
  ${AdmissionRoundExamRequiredDetailFragment}
  ${AdmissionRoundFragment}
`;
